import React from "react";
import FirmwarePackages from "./FirmwarePackages";
import { Modal, useModal } from "./Modal";

const FirmwareBundlesContent = ({ version }) => {
  const { isOpen, open, close } = useModal();

  return (
    <>
      <button
        onClick={open}
        className="dropdown-item"
        title="Show firmware packages"
      >
        Packages
      </button>
      <Modal
        title={`Firmware packages ${version}`}
        isOpen={isOpen}
        size="lg"
        isScrollable={true}
        onClose={close}
      >
        <FirmwarePackages version={version} />
      </Modal>
    </>
  );
};

export default FirmwareBundlesContent;
